import { useCallback, useEffect } from "react";
import { useAppSelector } from "@/core/store/reduxHooks";
import { getCurrentTheme, storeCurrentTheme } from "@/core/store/app/AppSlice";
import { useDispatch } from "react-redux";
import { getCookie, hasCookie, setCookie } from "cookies-next";

export const useDarkTheme = (): {
  currentTheme: string;
  switchTheme: () => void;
} => {
  const currentTheme = useAppSelector(getCurrentTheme);

  const dispatch = useDispatch();

  const switchTheme = useCallback(() => {
    const nextTheme = currentTheme === "" ? "dark" : "";
    setCookie("theme", nextTheme);
    dispatch(storeCurrentTheme(nextTheme));
  }, [currentTheme, dispatch]);

  useEffect(() => {
    if (hasCookie("theme") && getCookie("theme") !== currentTheme) {
      switchTheme();
    }
  }, [currentTheme, switchTheme]);

  return { currentTheme, switchTheme };
};
